var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", [
    _c(
      "div",
      { staticClass: "avue-crud" },
      [
        _c(
          "el-form",
          { attrs: { inline: true } },
          [
            _c(
              "el-form-item",
              [
                _vm.permissions.sys_menu_add
                  ? _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-plus", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addOrUpdateHandle(false)
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\t\t添加\n\t\t\t\t")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              data: _vm.menuList,
              "tree-props": {
                children: "children",
                hasChildren: "hasChildrens",
              },
              border: "",
              "row-key": "id",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                label: "菜单名称",
                prop: "name",
                width: "180",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "图标",
                prop: "icon",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("i", { class: scope.row.icon })]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "排序", prop: "sort", width: "60" },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                label: "组件路径",
                prop: "path",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "类型",
                prop: "type",
                width: "80",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.type === "0"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("左菜单"),
                          ])
                        : _vm._e(),
                      scope.row.type === "2"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("顶菜单"),
                          ])
                        : _vm._e(),
                      scope.row.type === "1"
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("按钮"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "缓冲",
                prop: "keepAlive",
                width: "80",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.keepAlive === "0"
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("关闭"),
                          ])
                        : _vm._e(),
                      scope.row.keepAlive === "1"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("开启"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                label: "权限标识",
                prop: "permission",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "class-name": "small-padding fixed-width",
                label: "操作",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.permissions.sys_menu_add
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-plus",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addOrUpdateHandle(
                                    false,
                                    scope.row.id
                                  )
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t\t新增\n\t\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.permissions.sys_menu_edit
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-edit",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addOrUpdateHandle(
                                    true,
                                    scope.row.id
                                  )
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t\t修改\n\t\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.permissions.sys_menu_del
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-delete",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t\t删除\n\t\t\t\t\t")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm.addOrUpdateVisible
          ? _c("table-form", {
              ref: "addOrUpdate",
              on: { refreshDataList: _vm.getList },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }